import SectionHeading from "./SectionHeading";
import { testimonials } from "@/mocks/home";

export default function Testimonials() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          align="center"
          eyebrow="投稿人反馈"
          title="他们投稿之后，这样评价"
          desc="以下内容来自已采纳线索投稿人的真实反馈，姓名与身份均已按要求匿名处理。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col p-6 md:p-7 rounded-lg bg-background-100 border border-background-200"
            >
              <i className="ri-double-quotes-l text-3xl text-primary-300"></i>
              <blockquote className="mt-4 text-sm text-foreground-700 leading-relaxed flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-background-200 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-secondary-200 text-secondary-800 flex items-center justify-center">
                  <i className="ri-user-line"></i>
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}